import { registerLocale } from '@costar/react-datepicker';
import arSA from 'date-fns/locale/ar-SA';
import cs from 'date-fns/locale/cs';
import da from 'date-fns/locale/da';
import de from 'date-fns/locale/de';
import el from 'date-fns/locale/el';
import enCA from 'date-fns/locale/en-CA';
import enGB from 'date-fns/locale/en-GB';
import enUS from 'date-fns/locale/en-US';
import es from 'date-fns/locale/es';
import faIR from 'date-fns/locale/fa-IR';
import fi from 'date-fns/locale/fi';
import frCA from 'date-fns/locale/fr-CA';
import he from 'date-fns/locale/he';
import hi from 'date-fns/locale/hi';
import hr from 'date-fns/locale/hr';
import hu from 'date-fns/locale/hu';
import it from 'date-fns/locale/it';
import ja from 'date-fns/locale/ja';
import nb from 'date-fns/locale/nb';
import nl from 'date-fns/locale/nl';
import pl from 'date-fns/locale/pl';
import pt from 'date-fns/locale/pt';
import sk from 'date-fns/locale/sk';
import sv from 'date-fns/locale/sv';
import th from 'date-fns/locale/th';
import zhCN from 'date-fns/locale/zh-CN';
import fastMemoize from 'fast-memoize';
import locale from '../locale/en-ZA/index.esm.js';
import locale$1 from '../locale/en-ZW/index.esm.js';
import locale$2 from '../locale/fr/index.esm.js';

var defaultLocaleSpec = enUS;
var languageOptions = {
  'ar-SA': 'Arabic Saudi Arabia',
  'cs-CZ': 'Czech',
  'da-DK': 'Danish',
  'de-DE': 'German',
  el: 'Greek',
  'en-CA': 'English Canadian',
  'en-GB': 'English UK',
  'en-US': 'English US',
  'en-ZA': 'English South Africa',
  'en-ZW': 'English Zimbabwe',
  'es-ES': 'Spanish',
  'es-MX': 'Spanish Mexico',
  'es-419': 'Spanish Latin America',
  'fa-IR': 'Farsi',
  'fi-FI': 'Finish',
  'fr-CA': 'French Canadian',
  'fr-FR': 'French',
  'he-IL': 'Hebrew',
  hi: 'Hindi',
  'hr-HR': 'Croatian',
  'hu-HU': 'Hungarian',
  'it-IT': 'Italiano',
  'ja-JP': 'Japanese',
  'nb-NO': 'Norwegian Bokmal',
  'nl-NL': 'Nederlands',
  'nn-NO': 'Norwegian Nynorsk',
  'pl-PL': 'Polish',
  'pt-PT': 'Português',
  'sk-SK': 'Slovak',
  'sv-SE': 'Swedish',
  'th-TH': 'Thai',
  'zh-CN': 'Chinese-China'
};
var languageKeys = Object.keys(languageOptions);
var language = {
  'ar-SA': arSA,
  'cs-CZ': cs,
  'da-DK': da,
  'de-DE': de,
  el: el,
  'en-CA': enCA,
  'en-GB': enGB,
  'en-US': enUS,
  'en-ZA': locale,
  'en-ZW': locale$1,
  'es-ES': es,
  'es-MX': es,
  'es-419': es,
  'fa-IR': faIR,
  'fi-FI': fi,
  'fr-CA': frCA,
  'fr-FR': locale$2,
  'he-IL': he,
  hi: hi,
  'hr-HR': hr,
  'hu-HU': hu,
  'it-IT': it,
  'ja-JP': ja,
  'nb-NO': nb,
  'nl-NL': nl,
  'nn-NO': nb,
  'pl-PL': pl,
  'pt-PT': pt,
  'sk-SK': sk,
  'sv-SE': sv,
  'th-TH': th,
  'zh-CN': zhCN
};

// code to use with native standard javaScript Intl.NumberFormat and Intl.DateTimeFormat()
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl
var BCP47langueCode = {
  'ar-SA': 'ar-SA',
  'fa-IR': 'fa-IR',
  'th-TH': 'th-TH-u-nu-thai',
  hi: 'hi-u-nu-deva'
};
var getLocaleFormattedYear = function getLocaleFormattedYear(locale, year) {
  var _parts$find, _parts$find2;
  var parts = new Intl.DateTimeFormat(
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  locale in BCP47langueCode ? BCP47langueCode[locale] : locale).formatToParts(new Date(year, 0, 1));
  var formatYear = (_parts$find = parts.find(function (i) {
    return i.type === 'year';
  })) === null || _parts$find === void 0 ? void 0 : _parts$find.value;
  var era = (_parts$find2 = parts.find(function (i) {
    return i.type === 'era';
  })) === null || _parts$find2 === void 0 ? void 0 : _parts$find2.value;
  return formatYear ? "".concat(era ? era : '').concat(formatYear) : "".concat(year);
};
var getLocaleNumeric = fastMemoize(function (locale) {
  return fastMemoize(function (value) {
    return locale ? new Intl.NumberFormat(locale in BCP47langueCode ? BCP47langueCode[locale] : locale).format(value) : "".concat(value);
  });
});
var isSupportedLocal = function isSupportedLocal(subject) {
  return typeof subject === 'string' && languageKeys.includes(subject);
};
var isRtlCulture = function isRtlCulture(locale) {
  return ['ar-SA', 'fa-IR', 'he'].includes(locale);
};
var registerCulture = (function () {
  var registerList = [];
  return function (locale) {
    if (locale && !registerList.includes(locale)) {
      registerList.push(locale);
      registerLocale(locale, locale in language ? language[locale] : language['en-US']);
    }
  };
})();

export default registerCulture;
export { BCP47langueCode, defaultLocaleSpec, getLocaleFormattedYear, getLocaleNumeric, isRtlCulture, isSupportedLocal, languageKeys, languageOptions };
//# sourceMappingURL=register-culture.esm.js.map
